<div class="dashboard-content position-relative">

    <app-loader [loading]="loading"></app-loader>

    <div class="row mb-4">
        <app-stat [documentsCount]="documentsCount" [planInfo]="planInfo">
        </app-stat>
    </div>

    <div class="row">
        <div class="col-lg-8">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title mb-4">Recent Documents</h4>

                    <div class="table-responsive">

                        @if(!loading && recentDocs && recentDocs.length > 0){
                        <table class="table table-centered">
                            <thead class="table-light">
                                <tr>
                                    <th>Document ID</th>
                                    <th>Date</th>
                                    <th>Doc Name</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for(item of recentDocs; track item){
                                <tr>
                                    <td>{{item.documentId}}</td>
                                    <td>{{item.createdAt | date}}</td>
                                    <td>{{item.name}}</td>
                                    <td>
                                        <div class="badge font-size-12" [ngClass]="{
                          'bg-danger-subtle text-danger': item.status === 'Chargeback',
                          'bg-success-subtle text-success': item.status === 'Signed',
                          'bg-warning-subtle text-warning': item.status === 'Pending'
                        }">
                                            {{item.status}}
                                        </div>
                                    </td>
                                </tr>
                                }
                            </tbody>
                        </table>
                        }

                        @if(!loading && recentDocs.length == 0){
                        <div class="text-center fw-bold">
                            No documents available.
                        </div>
                        }

                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-4">
            <div class="card">
                <div class="card-body">

                    <div class="float-end">
                        <select class="form-select" [(ngModel)]="selectedMonth.value" (change)="getMontlyDocStatus()">
                            <option *ngFor="let m of months" [value]="m.value">
                                {{ m.label }}
                            </option>
                        </select>
                    </div>

                    <h4 class="card-title mb-4">
                        Usage This Month
                    </h4>

                    @if(monthlyData?.length){

                    <apx-chart dir="ltr" class="apex-charts" [series]="salesAnalytics.series"
                        [chart]="salesAnalytics.chart" [labels]="salesAnalytics.labels" [legend]="salesAnalytics.legend"
                        [colors]="salesAnalytics.colors" [dataLabels]="salesAnalytics.dataLabels"
                        [plotOptions]="salesAnalytics.plotOptions" [tooltip]="salesAnalytics.tooltip">
                    </apx-chart>

                    <div class="row">
                        @for(data of monthlyData; track data){
                        <div class="col-4">
                            <div class="text-center mt-3">
                                <p class="mb-2 text-truncate">
                                    <i class="mdi mdi-circle font-size-10 me-1" [ngClass]="{
                        'text-primary': data.status === 'Pending',
                        'text-success': data.status === 'Signed',
                        'text-warning': data.status === 'Cancelled'
                      }">
                                    </i>
                                    {{data.status}}
                                </p>

                                <h5>{{data.count}}</h5>
                            </div>
                        </div>
                        }
                    </div>

                    } @else {
                    <div class="text-center fw-bold">
                        No data available.
                    </div>
                    }

                </div>
            </div>
        </div>
    </div>

</div>